import { createMuiTheme } from '@material-ui/core/styles'
import * as colorpacks from './colorpacks'

const indigo = '#3f51b5'
const babyBlue = '#e1eff7'
const turquoise = '#2f749c'
const white = '#fff'
const lightGray = '#efeeee'
const gray = '#999999'

const { grays, bluegrays } = colorpacks

const defaultPalette = {
  primary: {
    light: babyBlue,
    main: indigo, // headers etc
    dark: turquoise,
    contrastText: white // fonts based on main background
  },
  secondary: {
    light: grays.gray2,
    main: grays.gray9
  }
}

const testPalette = {
  primary: {
    light: babyBlue,
    main: grays.gray11, // headers etc
    dark: turquoise,
    contrastText: white // fonts based on main background
  },
  secondary: {
    light: grays.gray1,
    main: grays.gray3
  }
}

export default createMuiTheme({
  palette: defaultPalette,
  themeName: 'FlightTheme',
  typography: {
    useNextVariants: true
  }
})
